<template>
  <div class="hezuo-wrapper">
    <!-- <div class="hezuo-top">
      <div class="hezuo-inner">
        <div class="left" v-if="isPc">
          <img src="https://static.worldaic.com.cn/2024/web/static/images/meiti1-en.png" class="img-en img-en1" v-if="En" alt=""></img>
          <img src="https://static.worldaic.com.cn/2024/web/static/images/meiti1.png" v-else alt=""></img>
        </div>
        <div class="left" v-else>
          <img src="https://static.worldaic.com.cn/2024/web/static/images/meiti1-mobile-en.png" class="img-en img-en1" v-if="En" alt=""></img>
          <img src="https://static.worldaic.com.cn/2024/web/static/images/meiti1.png" v-else alt=""></img>
        </div>
        <div class="right">
            <img class="logo" v-for="(item, index) in list1" :key="index" :src="item.enterpriseLogoPc" alt="">
        </div>
      </div>
      <div class="hezuo-inner">
        <div class="left" v-if="isPc">
          <img src="https://static.worldaic.com.cn/2024/web/static/images/meiti2-en.png" class="img-en img-en1" v-if="En" alt=""></img>
          <img src="https://static.worldaic.com.cn/2024/web/static/images/meiti2.png" v-else alt=""></img>
        </div>
        <div class="left" v-else>
          <img src="https://static.worldaic.com.cn/2024/web/static/images/meiti2-mobile-en.png" class="img-en img-en1" v-if="En" alt=""></img>
          <img src="https://static.worldaic.com.cn/2024/web/static/images/meiti2.png" v-else alt=""></img>
        </div>
        <div class="right">
            <img class="logo" v-for="(item, index) in list2" :key="index" :src="item.enterpriseLogoPc" alt="">
        </div>
      </div>
    </div> -->
    <div class="hezuo" v-for="(ite, ind) in data" :key="ind">
      <div class="left">
        <!-- {{ $t('pastPartnerMedia') }} -->
        <!-- <img src="https://static.worldaic.com.cn/2024/web/static/images/meiti3-en.png" class="img-en" v-if="En" alt=""></img>
        <img src="https://static.worldaic.com.cn/2024/web/static/images/meiti3.png" v-else alt=""></img> -->
        <div class="text">{{ ite['title' + En] }}</div>
      </div>
      <div class="right" ref="right" v-if="ite.List && ite.List.length">
        <swiper ref="mySwiper" :options="swiperOptions" class="my-swiper" style="margin-left: -0.8rem; width: 100%">
          <swiper-slide v-for="(item, index) in ite.List.slice(0, Math.ceil(ite.List.length / 2))" :key="index">
            <img class="logo" :src="item.enterpriseLogoPc" alt="">
          </swiper-slide>
        </swiper>
        <swiper ref="mySwiper" :options="swiperOptions" class="my-swiper" style="width: 100%">
          <swiper-slide v-for="(item, index) in ite.List.slice(Math.ceil(ite.List.length / 2))" :key="index">
            <img class="logo" :src="item.enterpriseLogoPc" alt="">
          </swiper-slide>
        </swiper>
        <div class="mask-left"></div>
        <div class="mask-right"></div>
        <!-- <img class="mask-left" src="https://static.worldaic.com.cn/2024/web/static/images/mask-left.png" alt=""> -->
        <!-- <img class="mask-right" src="https://static.worldaic.com.cn/2024/web/static/images/mask-right.png" alt=""> -->
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    }
  },
  name: 'hezuo',
  data() {
    return {
      activeIndex: 0,
      allList: [],
      swiperOptions: {
        autoplay: 2000,
        speed: 2000,
        slidesPerView: 7,
        autoplayDisableOnInteraction : false,
        loop: true
      },
      length: 0,
      list1: [],
      list2: []
    }
  },
  created() {
    
  },
  mounted() {
    
  },
  watch: {
    // data: {
    //   handler(v) {
    //     if (v.length) {
    //       let list = v[0].List || []
    //       let arr1 = []
    //       let arr2 = []
    //       let arr = []
    //       list.forEach(x => {
    //         if (['第一财经', '央视网'].includes(x.enterpriseName)) {
    //           arr1.push(x)
    //         } else if (['浦东新区融媒体中心', '财联社'].includes(x.enterpriseName)) {
    //           arr2.push(x)
    //         } else {
    //           arr.push(x)
    //         }
    //       })
    //       this.list1 = arr1
    //       this.list2 = arr2
    //       this.length = Math.ceil(arr.length / 2)
    //       this.allList = arr
    //     }
    //   }
    // }
  },
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
  .hezuo-wrapper {
    width: 100%;
    height: 4.18rem;
    background: url("https://static.worldaic.com.cn/2024/web/static/images/hezuo-bg.jpg");
    background-size: cover;
    padding: 0 1.1rem;
  }
  .hezuo {
    position: relative;
    width: 100%;
    height: 2rem;
    display: flex;
    margin: 0 auto;
    background: rgba(255, 255, 255, .4);
    overflow: hidden;
    border-radius: .16rem;

    .left {
      position: relative;
      flex: 0 0 3.1rem;
      height: 2rem;
      display: flex;
      align-items: center;
      font-size: .36rem;
      font-weight: 500;
      color: #343434;
      line-height: 1;
      justify-content: center;
      
      .text {
          font-size: 0.22rem;
          font-weight: bold;
          color: #000;
          line-height: 0.32rem;
      }

      img {
        height: .3rem;
        width: auto;

        &.img-en {
          height: .36rem;

          &.img-en1 {
            height: .72rem;
          }
        }
      }

      &::after {
        content: "";
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: .02rem;
        height: 1.6rem;
        background: url("https://static.worldaic.com.cn/2024/web/static/images/line.png");
        background-size: 100% 100%;
      }
    }

    .right {
      flex: 1;
      position: relative;
      flex: 0 0 15.09rem;
      overflow: hidden;
      
      .mask-left {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 2rem;
        height: 100%;
        z-index: 1;
        background: linear-gradient(to right, RGBA(236, 232, 225, 1) 0%, RGBA(236, 232, 225, 0) 100%);
      }
      
      .mask-right {
        position: absolute;
        right: -0.2rem;
        bottom: 0;
        width: 2.5rem;
        height: 100%;
        z-index: 1;
        background: linear-gradient(to left, RGBA(236, 232, 225, 1) 0%, RGBA(236, 232, 225, 0) 100%);
      }
      
      img {
        width: 2rem;
        height: 1rem;
        cursor: pointer;
        margin-right: .12rem;
        padding: .2rem 0.4rem;
        object-fit: contain;
      }
    }
  }

  .hezuo-top {
    width: 100%;
    height: 1.4rem;
    margin-bottom: .22rem;
    display: flex;
    justify-content: space-between;

    .hezuo-inner {
      width: 8.4rem;
      height: 100%;
      background: rgba(255, 255, 255, .4);
      display: flex;
      border-radius: .16rem;

      .left {
        position: relative;
        flex: 0 0 3.1rem;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          height: .3rem;
          width: auto;

          &.img-en {
            height: .36rem;

            &.img-en1 {
              height: .72rem;
            }
          }
        }

        &::after {
          content: "";
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: .02rem;
          height: .68rem;
          background: url("https://static.worldaic.com.cn/2024/web/static/images/line.png");
          background-size: 100% 100%;
        }
      }

      .right {
        padding-left: .28rem;
        display: flex;
        align-items: center;

        img {
          width: 2rem;
          height: 1rem;
          cursor: pointer;
        }
      }
    }
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .hezuo-wrapper {
    width: 100%;
    background: url("https://static.worldaic.com.cn/2024/web/static/images/hezuo-bg.jpg");
    background-size: cover;
    padding: .17rem 0.32rem .17rem;
  }

  .hezuo {
    position: relative;
    width: 100%;
    height: 3.16rem;
    background: rgba(255, 255, 255, .4);
    overflow: hidden;
    padding: .3rem;
    border-radius: .16rem;

    .left {
      position: relative;
      font-size: .36rem;
      font-weight: 500;
      color: #343434;
      line-height: 1;

      img {
        width: auto;
        height: .3rem;
      }
    }

    .right {
      position: relative;
      width: 14.56rem;
      margin-top: .36rem;
      
      .mask-left {
        position: absolute;
        left: -0.8rem;
        top: 0;
        width: 1.8rem;
        height: 50%;
        z-index: 1;
      }
      
      .mask-right {
        position: absolute;
        left: 6rem;
        bottom: 0;
        height: 100%;
        width: 1.5rem;
        height: 50%;
        z-index: 1;
      }
      
      img {
        width: 2.04rem;
        height: 1.02rem;
        cursor: pointer;
        margin-right: .2rem;
      }
    }
  }

  .hezuo-top {
    width: 100%;

    .hezuo-inner {
      width: 100%;
      height: 2.2rem;
      margin-bottom: .2rem;
      background: rgba(255, 255, 255, .4);
      border-radius: .16rem;
      padding: .3rem;

      .left {

        img {
          height: .3rem;
          width: auto;
        }
      }

      .right {
        display: flex;
        align-items: center;
        margin-top: .3rem;

        img {
          width: 2rem;
          height: 1rem;
          cursor: pointer;
        }
      }
    }
  }
    
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/hezuo.vue